import { render, staticRenderFns } from "./salesOrder.vue?vue&type=template&id=2219edcb&scoped=true"
import script from "./salesOrder.vue?vue&type=script&lang=js"
export * from "./salesOrder.vue?vue&type=script&lang=js"
import style0 from "./salesOrder.vue?vue&type=style&index=0&id=2219edcb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219edcb",
  null
  
)

export default component.exports